export default Object.freeze({
  WorkplaceRegisterExportFlag:
    'R2B_Web_SelfService_EnableWorkplaceRegisterExport',
})
